import {
  Component,
} from "@angular/core";

@Component({
  selector: "cradua-acquisition",
  templateUrl: "./acquisition.component.html",
  styleUrls: ["./acquisition.component.scss"],
})
export class AcquisitionComponent {

}
